export default __webpack_public_path__ + "static/media/WaterMyPlantsLogo.801cd9d0.png";